import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditPressureMonitorForm from './forms/EditPressureMonitorForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { createPressureMonitorAction } from '../actions/pressureMonitorsActions'
import { createQueryString } from '../utils/queryParams'

class CreatePressureMonitor extends Component {
  static propTypes = {
    getAllAssetLocations: PropTypes.func.isRequired,
    assetLocations: PropTypes.arrayOf(PropTypes.object),
  }

  componentDidMount() {
    const { getAllAssetLocations } = this.props
    const qs = createQueryString({ perPage: 'all' })

    getAllAssetLocations(qs)
  }

  render() {
    const { assetLocations } = this.props
    const crumbs = [
      <Anchor to="/inventory/all">Inventory</Anchor>,
      <Anchor to="/inventory/all/pressure-monitors">
        Pressure Monitors
      </Anchor>,
      'Create Pressure Monitor',
    ]

    return (
      <section className="CreatePressureMonitor">
        <FormHeader crumbs={crumbs} />
        <EditPressureMonitorForm
          submitAction={createPressureMonitorAction}
          assetLocations={assetLocations}
          initialValues={{ measurementUnits: 1 }}
        />
      </section>
    )
  }
}

export default CreatePressureMonitor
